import { UniformSlot } from '@uniformdev/canvas-react';

const UniformVariant = () => {
	return <UniformSlot name="content" />;
};

export default UniformVariant;
